import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || status === 'submitting') return;

    setStatus('submitting');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d8r5n3le8ise6dlc8i70', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-2xl mx-auto text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
          Stay Updated
        </span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mt-3 leading-tight">
          Get the Latest LitBuy<br />
          Spreadsheet Updates
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600">
          Subscribe to receive new spreadsheet releases, category updates, 
          and shopping tips directly in your inbox.
        </p>

        <form
          data-readdy-form
          id="newsletter-form"
          onSubmit={handleSubmit}
          className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            required
            className="flex-1 px-4 py-3 rounded-full border border-background-300/60 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'submitting' ? (
              'Subscribing...'
            ) : (
              <>
                Subscribe
                <span className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </>
            )}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-3 text-sm text-primary-600 font-medium">
            Thank you for subscribing! We will keep you updated.
          </p>
        )}
        {status === 'error' && (
          <p className="mt-3 text-sm text-accent-600 font-medium">
            Something went wrong. Please try again later.
          </p>
        )}
      </div>
    </section>
  );
}